import PriceChart from './PriceChart';

export default PriceChart;
